'use strict';

/**
 * A searchable options list directive that takes in options to display in a searchable list
 * and keeps track of which options were selected, invoking callbacks when selection changes occur.
 */
angular.module('dashboard')
    .directive('searchableOptionList', ['$timeout',
        function ($timeout) {
            return {
                scope: {
                    listName: '@listName',
                    validationText: '@validationText',
                    searchText: '@searchText',
                    selectorType: '=selectorType',
                    optionList: '=optionList',
                    listParentId: '=listParentId',
                    selectedItems: '=selectedItems',
                    onChangeCallBack: '=onChangeCallBack',
                    showValidation: '=showValidation'
                },
                templateUrl: 'components/formcontrols/searchableoptionlist/searchableoptionlist.2c86744c.html',
                restrict: 'E',
                link: function postLink(scope, element, attrs) {

                    /**
                     * Initialise the scope
                     */
                    var initialise = function () {
                        scope.showValidation = false;
                        scope.$watchCollection('optionList', function () {
                            self.searchList = $('#{0}'.format(scope.listName)).searchableOptionList({
                                data: function() {
                                    var options = [];
                                    _.each(scope.optionList, function (option) {
                                        var selected = _.some(scope.selectedItems, function (item) {
                                            return option.Id === item;
                                        });
                                        option = {
                                            "type":  "option",
                                            "label": option.Name,
                                            "value": option.Id,

                                            // optional attributes
                                            "selected": selected          // true or false, determines whether this entry is preselected
                                        };
                                        options.push(option);
                                    });
                                    return options;
                                },
                                // register events
                                events: {
                                    onChange: function (sol, changedElements) {
                                        $timeout(function () {
                                            var isAdding = false;
                                            if (changedElements[0].checked) {
                                                scope.selectedItems.push(parseInt(changedElements[0].value));
                                                isAdding = true;
                                            }
                                            else {
                                                var index = scope.selectedItems.indexOf(parseInt(changedElements[0].value));
                                                scope.selectedItems.splice(index, 1);
                                            }
                                            if (scope.selectedItems.length === 0) {
                                                scope.showValidation = true;
                                            }
                                            else {
                                                scope.showValidation = false;
                                            }
                                            scope.onChangeCallBack(scope.listParentId, parseInt(changedElements[0].value), isAdding, scope.selectorType);
                                        });
                                    }
                                },
                                texts: {
                                    searchplaceholder: scope.searchText
                                }
                            });
                        });

                        // When the scope is destroyed, remove reference to the element
                        scope.$on('destroy', function () {
                            self.searchList = null;
                        });
                    };

                    initialise();
                }
            };
        }]);